import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Send } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-zinc-950 text-white relative overflow-hidden" data-id="element-11">
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-13">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-14">
            Потрібна термінова допомога?
          </h2>
          <p className="text-xl text-zinc-400 mb-12 max-w-2xl mx-auto font-medium" data-id="element-15">
            Зв'яжіться з нами прямо зараз для отримання первинної консультації
            та оцінки вашої ситуації.
          </p>

          <div className="bg-zinc-900 border border-zinc-800 p-8 md:p-12 rounded-3xl shadow-2xl max-w-2xl mx-auto" data-id="element-16">
            <div className="mb-10" data-id="element-17">
              <p className="text-zinc-500 font-bold mb-3 uppercase tracking-widest text-xs" data-id="element-18">
                Прямий зв'язок з адвокатом
              </p>
              <a href="tel:+380688087800" className="text-4xl md:text-5xl font-black text-white hover:text-zinc-300 transition-colors inline-flex items-center gap-4" data-id="element-19">
                <Phone size={36} className="text-zinc-500" data-id="element-20" />
                +38 068 808 78 00
              </a>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-21">
              <a href="https://t.me/+380688087800" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-[#2AABEE] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#2298D6] transition-colors" data-id="element-22">
                <Send size={20} data-id="element-23" />
                Написати в Telegram
              </a>
              <a href="viber://chat?number=%2B380688087800" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-[#7360F2] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#5E4CDA] transition-colors" data-id="element-24">
                <MessageCircle size={20} data-id="element-25" />
                Написати у Viber
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}